import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1265.232 -4200.39)">
      <path
        d="M375.518,38.14a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1625 4163)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M388.5,45.646a15.03,15.03,0,0,0-12.98-7.506v15l-12.98-7.494a15,15,0,1,0,25.96,0"
        transform="translate(-1625 4163)"
        fill={color}
      />
    </g>
  </svg>
);
